



































































































































































import Validation from "@/chipply/Validation";
import CartItemViewModel from "@/chipply/view-model/CartItemViewModel";
import CheckoutReviewViewModel from "@/chipply/view-model/CheckoutReviewViewModel";
import CartViewModel from "@/chipply/view-model/CartViewModel";
import PackageViewModel from "@/chipply/view-model/PackageViewModel";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import ICartItem from "@/chipply/ICartItem";
import EcomLayout from "./EcomLayout.vue";
import CartItemAttributeViewModel from "@/chipply/view-model/CartItemAttributeViewModel";
import { mask } from "vue-the-mask";
import { IOrderTotals, StorePriceDisplayType } from "chipply-common";
import CartItem from "./cart/CartItem.vue";
import OrderTotalSummary from "./price/OrderTotalSummary.vue";
import PriceDisplay from "./price/PriceDisplay.vue";
import IPriceDisplay from "@/chipply/interface/IPriceDisplay";
import CartAction from "./cart/CartAction.vue";
import Decimal from "decimal.js";

@Component({
    components: {
        EcomLayout,
        CartItem,
        CartAction,
        PriceDisplay,
        OrderTotalSummary,
    },
    directives: {
        mask,
    },
})
export default class Cart extends Vue {
    @Prop()
    public eventId!: number;

    @Prop()
    public isPreview!: boolean;

    public get mobile() {
        return !this.$vuetify.breakpoint.smAndUp;
    }

    public vm: CheckoutReviewViewModel = new CheckoutReviewViewModel();
    public cartVm: CartViewModel = new CartViewModel();
    public packageVm: PackageViewModel = new PackageViewModel();
    public alacart: Array<ICartItem> = [];

    public deleteTarget!: ICartItem | any;
    public showDialog = false;
    public cartFormValid = false;
    public packageFormValid = false;
    public qtyFormValid = false;
    public loading = true;
    public originalValue = "";
    private errorMessage = "";

    public get priceDisplay(): IPriceDisplay {
        return {
            displayType: this.cartVm.branding?.storePriceDisplayType,
            dollarValuePerPoint: this.cartVm.branding?.storeDollarValuePerPoint ?? 0,
        };
    }

    // @ts-ignore
    public $refs!: {
        cartForm: any;
        packageForm: any;
        qtyForm: any;
    };

    public get disableProceedToCheckout() {
        if (this.isPreview) {
            return true;
        }
        if (this.priceDisplay.displayType == StorePriceDisplayType.Points && this.estimateTotalDue > 0) {
            return true;
        }
        return false;
    }

    public async created() {
        await this.cartVm.getBranding(this.eventId);
        await this.cartVm.getCartItems(this.eventId, true, true);

        this.refreshAlacart();

        this.vm.eventId = this.eventId;
        this.vm.allowCoupon = this.cartVm.branding.allowCoupon;
        this.vm.allowEcert = this.cartVm.branding.allowEcert;

        await this.vm.getBrandingInfo(this.eventId);
        await this.preloadAppliedCodesFromSession();
        this.loading = false;
    }

    private refreshAlacart() {
        this.alacart = [];
        this.cartVm.contents.forEach((item) => {
            if (!item.packageId) {
                this.alacart.push(item);
            }
        });
    }

    public async quantitySelected(value: string, item: ICartItem) {
        let num = parseInt(value.slice(4));
        await this.cartVm.changeItemQuantity(num, item.cartItemId);
        //get items again to refresh the subtotal
        await this.cartVm.getCartItems(this.eventId, true, true);
        this.refreshAlacart();
    }

    protected async changeQty(amount: number, item: ICartItem) {
        item.errorMessage = "";
        const liveMax = this.cartVm.getCorrectLiveMax(item);
        const adjustedValue = parseInt(item.itemQuantity.toString()) + amount;
        if (amount > 0) {
            if (adjustedValue <= liveMax) {
                item.itemQuantity++;
            } else {
                item.errorMessage = "Max Quantity Reached";
                return;
            }
        } else {
            if (item.itemQuantity != 1) {
                if (adjustedValue >= item.minQuantity) {
                    item.itemQuantity--;
                } else {
                    item.errorMessage = "Min Quantity Reached";
                    return;
                }
            }
        }

        if (item.itemQuantity > liveMax) {
            item.errorMessage = "Product quantity must be between " + item.minQuantity + " and " + liveMax;
        }
        if (this.cartVm.validateQuantity(item)) {
            this.loading = true;
            await this.cartVm.changeItemQuantity(item.itemQuantity, item.cartItemId);
            await this.cartVm.getCartItems(this.eventId, true, true);
            await this.cartVm.clearErrors();
            this.refreshAlacart();
            this.clearAlacartErrors();
            item.displayQuantity = item.itemQuantity;
            this.loading = false;
        }
    }

    protected clearAlacartErrors() {
        this.alacart.forEach((item) => {
            item.errorMessage = "";
        });
    }

    protected async handleApplyCode() {
        const products = this.alacart.map((item) => {
            return { eventProductId: item.eventProductId, itemTotal: item.itemTotal };
        });

        this.cartVm.packages.forEach((value, key) => {
            value.nPackageArray.forEach((item) => {
                products.push({ eventProductId: item.eventProductId, itemTotal: item.itemTotal });
            });
        });

        const totals = { ...this.estimateTotals };
        const results = await this.vm.applyCouponOrEcert(totals, products);
        if (results.isSuccess == true) {
            if (results.type == "coupon") {
                this.couponTotal = totals.couponTotal;
            }
            this.checkWhetherTotalIsCoveredOrNot();
        }
    }

    protected async preloadAppliedCodesFromSession() {
        const products = this.alacart.map((item) => {
            return { eventProductId: item.eventProductId, itemTotal: item.itemTotal };
        });

        const totals = { ...this.estimateTotals };
        const results = await this.vm.preloadAppliedCodesFromSessionWithProvidedTotalsAndProducts(totals, products);
        if (results.couponApplied == true) {
            this.couponTotal = totals.couponTotal;
        }

        this.checkWhetherTotalIsCoveredOrNot();
    }

    protected validateManualQty(item: ICartItem, event: any) {
        item.itemQuantity = parseInt(event);
        if (item) {
            var liveMax = this.cartVm.getCorrectLiveMax(item);
            if (item.minQuantity <= item.itemQuantity && item.itemQuantity <= liveMax) {
                item.errorMessage = "";
                return true;
            } else if (item.itemQuantity > liveMax && item.minQuantity == liveMax) {
                item.errorMessage = "Product quantity must be " + item.minQuantity;
            } else {
                item.errorMessage = "Product quantity must be between " + item.minQuantity + " and " + liveMax;
                return false;
            }
        }
    }

    public async deleteSelected() {
        this.loading = true;
        if (this.deleteTarget[1]) {
            //this is a package
            const split = this.deleteTarget[0].split("_");

            await this.cartVm.deletePackage(split[0], this.deleteTarget[1].packageId, split[1], this.eventId);
            this.deleteTarget = "";
            await this.cartVm.getCartItems(this.eventId, true, true);
        } else {
            //this is an individual item
            await this.cartVm.deleteCartItem(this.deleteTarget.cartItemId);
            this.deleteTarget = "";
            await this.cartVm.getCartItems(this.eventId, true, true);
            this.alacart = [];
            this.cartVm.contents.forEach((item) => {
                if (!item.packageId) {
                    this.alacart.push(item);
                }
            });
        }

        this.checkWhetherTotalIsCoveredOrNot();
        this.loading = false;
    }

    protected validateOptionField(option: CartItemAttributeViewModel) {
        if (!option.isRequired || (option.userValue && option.userValue != "")) {
            return true;
        }
        return "Product Option required";
    }

    protected validateMaxLength(option: CartItemAttributeViewModel) {
        if (option.maxLength === 0) {
            return true;
        } else {
            return Validation.requireMaximumLengthOf(option.maxLength)(option.userValue);
        }
    }

    public async proceedToCheckout() {
        if (this.$refs.cartForm.validate() && this.$refs.packageForm.validate()) {
            if (!this.checkError()) {
                this.loading = true;
                await this.cartVm.proceedToCheckout();
                if (this.cartVm.cartErrorHeader) {
                    this.loading = false;
                }
            }
        }
    }

    public get estimateOrderTotal() {
        return this.estimateCartTotal + this.cartVm.handlingFee;
    }

    public get estimateTotals(): IOrderTotals {
        const totals: IOrderTotals = {
            cartTotal: this.estimateCartTotal,
            ecertTotal: this.estimateEcertTotal,
            shippingTotal: 0,
            handlingTotal: this.cartVm.handlingFee,
            taxTotal: 0,
            orderTotal: this.estimateOrderTotal,
            chipplyFeeTotal: 0,
            couponTotal: this.couponTotal,
        };
        return totals;
    }

    public couponTotal = 0;

    public get estimateEcertTotal() {
        var remainingBalance = this.estimateOrderTotal - this.couponTotal;
        let ecertTotal = 0;
        this.vm.appliedEcertCodes.every((ecertBalanceInfo) => {
            if (remainingBalance <= 0) {
                return false;
            }

            var amountToUse = Math.min(remainingBalance, ecertBalanceInfo.availableBalance);
            ecertTotal += amountToUse;
            remainingBalance -= amountToUse;
            return true;
        });
        return ecertTotal;
    }

    public get estimateCartTotal() {
        let cartTotal = 0;
        this.alacart.forEach((item) => {
            cartTotal += item.itemTotal;
        });

        this.cartVm.packages.forEach((value, key) => {
            cartTotal += value.nPackageArray.reduce((acc, item) => acc + item.itemTotal, 0);
        });
        return cartTotal;
    }

    public checkError() {
        let errorFlag = false;
        this.cartVm.contents.forEach((item) => {
            if (item.errorMessage != "" && item.errorMessage !== undefined) {
                errorFlag = true;
            }
        });
        this.alacart.forEach((item) => {
            if (item.errorMessage != "" && item.errorMessage !== undefined) {
                errorFlag = true;
            }
        });
        return errorFlag;
    }

    public async manualQtyChange(item: ICartItem) {
        if (this.cartVm.validateQuantity(item) == true) {
            item.errorMessage = "";
            this.loading = true;
            await this.cartVm.changeItemQuantity(item.itemQuantity, item.cartItemId);
            await this.cartVm.getCartItems(this.eventId);
            item.displayQuantity = item.itemQuantity;
            this.clearAlacartErrors();
            this.refreshAlacart();
            this.checkWhetherTotalIsCoveredOrNot();
            this.loading = false;
        }
    }

    public async optionChanged(cartItemVieModel: CartItemViewModel | ICartItem, option: CartItemAttributeViewModel) {
        if (this.validateOptionField(option) == true) {
            this.loading = true;
            const newPrice = await this.cartVm.updateOption(option.attributeName, option);
            cartItemVieModel.itemPrice = newPrice;
            this.alacart = [];
            await this.cartVm.getCartItems(this.eventId);
            this.refreshAlacart();
            this.checkWhetherTotalIsCoveredOrNot();
            this.loading = false;
        }
        option.valueChanged = false;
    }

    public deleteEcertCode($event: any) {
        this.vm.deleteEcertCode($event);
        this.checkWhetherTotalIsCoveredOrNot();
    }

    public deletePromoCode($event: any) {
        this.vm.deletePromoCode();
        this.couponTotal = 0;
        this.checkWhetherTotalIsCoveredOrNot();
    }

    public checkWhetherTotalIsCoveredOrNot() {
        this.vm.checkWhetherTotalIsCoveredOrNot(this.estimateTotalDue);
    }

    public get estimateTotalDue() {
        if (!this.estimateTotals) {
            return 0;
        }
        const result = new Decimal(this.estimateTotals.orderTotal)
            .minus(this.estimateTotals.ecertTotal)
            .minus(this.estimateTotals.couponTotal);
        return result.toNumber();
    }
}
